import { Ref } from 'vue';
import { TechDataVehicle } from '@/types';
import { pushDataLayerEvent } from '@/utils/tracking';

export function useTracking(modelSeries: string) {
  const trackFeatureSelection = (
    label: string,
    vehicle: TechDataVehicle | null,
  ) => {
    if (!vehicle) {
      console.warn('No vehicle selected for tracking.');
      return;
    }

    const formattedLabel = label.toLowerCase();

    pushDataLayerEvent({
      name: 'feature',
      category: 'feature',
      action: 'cvans_techdata_component',
      label: formattedLabel,
      vehicle: {
        modelCode: modelSeries,
        class: vehicle.vehicleClass,
        bodyType: vehicle.bodyType,
        baumusterId: vehicle.baumuster,
        type: 'van',
        category: 'commercial',
      },
    });
  };

  const trackSlider = (label: string, vehicle: TechDataVehicle) => {
    if (!vehicle) {
      console.warn('No vehicle selected for tracking.');
      return;
    }

    pushDataLayerEvent({
      name: 'feature',
      category: 'feature',
      action: 'cvans_techdata_component',
      label: label,
      vehicle: {
        modelCode: modelSeries,
        class: vehicle.vehicleClass,
        bodyType: vehicle.bodyType,
        baumusterId: vehicle.baumuster,
        type: 'van',
        category: 'commercial',
      },
    });
  };

  const trackAccordion = (label: string, vehicle: TechDataVehicle) => {
    if (!vehicle) {
      console.warn('No vehicle selected for tracking.');
      return;
    }

    pushDataLayerEvent({
      name: 'show_more_details',
      category: 'feature',
      action: 'cvans_techdata_component',
      label: label,
      vehicle: {
        modelCode: modelSeries,
        class: vehicle.vehicleClass,
        bodyType: vehicle.bodyType,
        baumusterId: vehicle.baumuster,
        type: 'van',
        category: 'commercial',
      },
    });
  };

  const trackImpression = (vehicle: TechDataVehicle) => {
    if (!vehicle) {
      console.warn('No vehicle selected for tracking.');
      return;
    }

    pushDataLayerEvent({
      name: 'impression',
      category: 'impression',
      action: 'cvans_techdata_component',
      label: 'cvans_techdata',
      vehicle: {
        modelCode: modelSeries,
        class: vehicle.vehicleClass,
        bodyType: vehicle.bodyType,
        baumusterId: vehicle.baumuster,
        type: 'van',
        category: 'commercial',
      },
    });
  };

  return {
    trackFeatureSelection,
    trackSlider,
    trackAccordion,
    trackImpression,
  };
}
